import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = {
  Projects: [],
  TotalCount: 0,
}

function _updateProject(state, updatedProject) {
  return {
    ...state,
    Projects: state.Projects.map((project) =>
      project.Id === updatedProject.Id ? { ...project, ...updatedProject } : project
    ),
  }
}

export default handleActions(
  {
    [rawActions.getProjects.success](state, { response }) {
      return { ...response.data }
    },
    [combineActions(rawActions.updateProject.success)](state, { response }) {
      return _updateProject(state, response.data)
    },
    [rawActions.deleteProject.success](state, action) {
      return {
        ...state,
        Projects: state.Projects.filter((project) => project.Id !== action.payload.projectId),
        TotalCount: state.TotalCount > 0 ? state.TotalCount - 1 : 0,
      }
    },
  },
  defaultState
)
